import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterExperimentalPageProjectDetail = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("experimental/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.PageProjectDetail />,
        });
      })
      .catch(reject);
  });
});

export const LazyExperimentalPageProjectDetail = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterExperimentalPageProjectDetail />
    </Suspense>
  );
};
